module.exports = "<button class=\"{{cssStyle}}\" ng-click=\"backToTop()\" ng-class=\"{ 'return-to-top-visible': showReturn, 'return-to-top-hide': !showReturn }\" >\r\n    <span class=\"line-arrow line-arrow--up\" aria-hidden=\"true\"></span>\r\n</button>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/return-to-top/return-to-top-template.html
 ** module id = 981
 ** module chunks = 1
 **/